import { render, staticRenderFns } from "./device-setup.vue?vue&type=template&id=52122f39&scoped=true&"
import script from "./device-setup.vue?vue&type=script&lang=ts&"
export * from "./device-setup.vue?vue&type=script&lang=ts&"
import style0 from "./device-setup.vue?vue&type=style&index=0&id=52122f39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52122f39",
  null
  
)

export default component.exports